<div class="salesdetailwrapper"> 
  <div class="salesreportwrapper">
   <div class="salesdetail d-flex">
     <div class="d-flex align-items-center"  (click)="goBack()"><img class="previewback" src="../../../../assets/images/storelist/backarrow.svg"> </div>
     <div class="previewcontent">
       <div class="text-heading-3 previewtext-content">Preview {{ productName }} Report</div>
       <div class="text-heading-5 d-flex align-items-center"><img class="calender-content" src="../../../../assets/images/storelist/calendar.svg">{{ changedStorePeriod }}</div>
     </div>
    </div>
    <button class="primary-btn" (click)="downloadSalesRecords(type, currentStoreId)">Download Report</button>
   </div>
    
  <div class="table-wrapper userstable">
   <table class="table">
     <thead>
       <tr>
         <th class="" scope="col">Stocks</th>
         <th class="" scope="col">Counts</th>
       </tr>
     </thead>
     <tbody>
       <tr>
         <td class="text-start">Total Stock</td>
         <td class="text-start">{{ paginationData.total }}</td>
       </tr>
     </tbody>
   </table>
 </div>
 <div class="table-wrapper">
   <table class="table">
     <thead>
       <tr>
         <th *ngFor="let heading of modifiedHeadings" class="" scope="col">{{ heading }}</th>
       </tr>
     </thead>
     <tbody>
       <tr *ngFor="let salesOrder of salesProducts">
         <td *ngFor="let heading of tableHeadings" class="text-start">{{ salesOrder[heading] }}</td>
       </tr>
     </tbody>
   </table>
 </div>

 <div class="" *ngIf="paginationData.totalPage > 1">
   <app-pagination [totalPages]="paginationData.totalPage" (queryPage)="getQueryPage($event)"></app-pagination>
 </div>

</div>
